export const CC_POI_DOCUMENTS_TYPES = {
  EU_ID: 'eu_id',
  EU_PASSPORT: 'eu_passport',
  RESIDENT_CARD: 'resident_card',
};
